import React from "react";

const iconDropdownHolder = {
  closeIconDropdown(e) {
    if (iconDropdownHolder.containerRef && !iconDropdownHolder.containerRef.current?.contains(e.target)) {
      iconDropdownHolder.internalStateSetter('isOpen', false);
      document.removeEventListener("mousedown", iconDropdownHolder.closeIconDropdown)
    }
  }
};

const controller = {
  'PriorityDropdown.Wrapper.HeaderWrapper': async ({ isOpen, containerRef }, _, internalStateSetter) => {

    let newContainerRef = containerRef;

    if (!containerRef) {
      newContainerRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef });
    }

    await internalStateSetter('isOpen', !isOpen);
    iconDropdownHolder.internalStateSetter = internalStateSetter;
    iconDropdownHolder.containerRef = newContainerRef;

    document.addEventListener("mousedown", iconDropdownHolder.closeIconDropdown);
  },
  'PriorityDropdown.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.LowPriorityWrapper.Option': ({ }) => { },
  'PriorityDropdown.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.HighPriorityWrapper.Option': ({ }) => { },
  'PriorityDropdown.Wrapper.HeaderWrapper.Option': ({ isOpen, containerRef }, _, internalStateSetter) => {
    controller['PriorityDropdown.Wrapper.HeaderWrapper']({ isOpen, containerRef }, () => { }, internalStateSetter);
  },
  'PriorityDropdown.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.HighPriorityWrapper.Icon': ({ priority_id, priority }, outlet, internalStateSetter) => {
    outlet({ id: priority.id === priority_id ? null : priority.id })
    internalStateSetter({ isOpen: false })
  },
  'PriorityDropdown.Wrapper.DropdownWrapper.BorderWrapper.ListWrapper.ListWrapper.LowPriorityWrapper.Icon': ({ priority_id, priority }, outlet, internalStateSetter) => {
    outlet({ id: priority.id === priority_id ? null : priority.id })
    internalStateSetter({ isOpen: false })
  }
};

export default controller;